import {useSelector} from 'react-redux';
import {selectFilterLoadingbarStatus, selectLoadingbarStatus} from '../../LoaderSlice.jsx';
import {useBreakpointUp, Spinner} from "bonprix-design-system";

export default function SideSheetLoader() {
    const breakpointLUp = useBreakpointUp('l');
    const loader = useSelector(selectLoadingbarStatus);
    const filterLoader = useSelector(selectFilterLoadingbarStatus);

    const isLoading = loader.status || (breakpointLUp && filterLoader.status);
    const showSpinner = loader.defaultCase || filterLoader.status;

    if (!isLoading) {
        return null;
    }

    return (
        <div className="filter-side-sheet__loader-wrapper">
            {showSpinner && <Spinner edgeLength="3.75rem" />}
        </div>
    );
}
